import { gql } from "@apollo/client";
import FormDialog from "controls/FormDialog";
import { useActionFragment } from "hooks/useAction";
import useData from "hooks/useData";
import { Pencil } from "mdi-material-ui";
import React from "react";

import CompetitionsForm, { CompetitionsFormFragment } from "./Form";

CompetitionsEditDialog.useButtonProps = () => {
  return {
    icon: <Pencil />,
    content: "Edit Settings",
  };
};

export default function CompetitionsEditDialog({ competitionIds, onSubmit, onClose }) {
  const competitionsUpdate = useActionFragment("competitionsUpdate");
  const [data, dataMeta] = useData(
    gql`
      query CompetitionBatchEditDialogQuery($competitionIds: [ID!]!) {
        competitions(ids: $competitionIds) {
          id
          ...CompetitionsFormFragment
        }
      }
      ${CompetitionsFormFragment}
    `,
    { competitionIds },
  );

  return (
    <FormDialog
      loading={dataMeta.loading}
      header="Edit Competition Settings"
      onClose={onClose}
      onSubmit={async (formData) => {
        await competitionsUpdate({
          input: {
            competitionIds,
            ...formData,
          },
        });
        await onSubmit?.();
      }}
    >
      <CompetitionsForm competitions={data?.competitions} />
    </FormDialog>
  );
}
